import { truncateText } from "@/services/generic.methods";
import Tooltip from "@mui/material/Tooltip";

const TruncateTooltip = ({
  text = "",
  limit = 15,
  position = "bottom",
  sx = {},
}) => {
  return text.length > limit ? (
    <Tooltip
      title={text}
      placement={position}
      enterDelay={200}
      leaveDelay={100}
    >
      <span style={{ ...sx }}>{truncateText(text, limit)}</span>
    </Tooltip>
  ) : (
    <span style={{ ...sx }}>{text}</span>
  );
};

export const TooltipComponent = ({ children, showTooltip, text = "" }) => {
  return showTooltip ? (
    <Tooltip title={text} placement="bottom" enterDelay={200} leaveDelay={100}>
      <span>{children}</span>
    </Tooltip>
  ) : (
    <span>{children}</span>
  );
};

export default TruncateTooltip;
